/**
 * Code to handle the network part of token handling:
 * - graphql queries and mutations
 * - functions to get tokens, etc
 */
import gql from 'graphql-tag';
import apollo from '../apollo';

import { PUBLIC_GRAPHQL_OPERATIONS } from '../../utils/Gr8piConfig';

const UPDATE_LOCALE = gql`
mutation updateLocale($username: String!, $preferredLanguage: Locale!) {
  updateLocale(username: $username, locale: $preferredLanguage) {
    id
  }
}
`;

export const updateLocale = input => apollo.mutate({
  mutation: UPDATE_LOCALE,
  variables: {
    username: input.username,
    preferredLanguage: input.preferredLanguage,
  },
});

const GENERATE_TOKEN_MUTATION = gql`
mutation generateToken($input: GenerateTokenInput!) {
  generateToken(input: $input) {
    token
    refreshToken
    userId
    error {
      type
      lockedOutTimestamp
    }
    isMultiFactorAuthentication
  }
}
`;

/**
 * Request access and refresh token from server using credentials.
 */
export const requestNewToken = credentials => apollo.mutate({
  mutation: GENERATE_TOKEN_MUTATION,
  variables: {
    input: credentials,
  },
  operationName: PUBLIC_GRAPHQL_OPERATIONS.generateToken,
});

const REFRESH_TOKEN_MUTATION = gql`
mutation refreshToken($input: String!) {
  refreshToken(refreshToken: $input) {
    token
  }
}
`;

/**
 * Request access token from server using refresh token.
 */
export const requestRefreshToken = credentials => apollo.mutate({
  mutation: REFRESH_TOKEN_MUTATION,
  variables: {
    input: credentials,
  },
  operationName: PUBLIC_GRAPHQL_OPERATIONS.refreshToken,
});
